import { getMembershipHref } from 'selectors/Organization';
import { organizationSelector } from 'selectors/Organization';
import { Organization } from 'stores/organizations/models';

export function href(state: any): string | undefined {
  const organization: Organization | undefined = organizationSelector(state);
  if (organization === undefined) {
    return undefined;
  }
  return getMembershipHref(organization.providerId, organization.slug);
}

export const selectors = {
  href,
};
